import React, {useContext} from 'react'
import {CheckboxPure} from '@modifi/ui'
import {KEY_JANUS, useTranslation} from '@modifi/plugin-i18n'
import {FormDataContext} from '@modifi/plugin-forms'
import * as PropTypes from 'prop-types'

const BrokerCheckBox = ({isBroker, onChange}) => {
  const {t} = useTranslation(KEY_JANUS)
  const {changeData} = useContext(FormDataContext)

  const handleChange = () => {
    changeData('exportVolumeCategory', null)
    onChange()
  }

  return (
    <CheckboxPure
      name="isBroker"
      label={t('signup.is-partner.label')}
      checked={isBroker || false}
      onChange={handleChange}
    />
  )
}

BrokerCheckBox.propTypes = {
  isBroker: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default BrokerCheckBox
